module.exports = __webpack_public_path__ + "img/status_6_white.795cbd44.svg";